import KIAImage from '../ui/image/KIAImage';

interface Props {
  image: string;
  mobileImage?: string;
}

const PrivateLeasingHero = ({ image, mobileImage }: Props) => {
  return (
    <section className="relative w-full h-[52vh] lg:h-[60vh] max-h-[918px] lg:max-h-[900px] text-white mb-4 lg:mb-10">
      <picture>
        <source media="(max-width: 1023px)" srcSet={mobileImage} />
        <KIAImage
          src={image}
          alt="En rad Kia-bilar parkerade vid vattnet i solnedgången."
          className="w-full h-full object-cover object-[center_60%] lg:object-[center_bottom]"
        />
      </picture>
    </section>
  );
};

export default PrivateLeasingHero;
